module.exports = __webpack_public_path__ + "img/foursome-ixtapa.df88b423.jpg";